<!-- 对公打款-账单 页 -->
<template>
    <div class="wrap">
        <h3 style="margin-bottom: 10px;">对公打款账单</h3>
        <template v-if="showAllContent">
            <div class="item-box">
                <div class="title-box" style="display: flex;justify-content: space-between;">
                    <div>
                        <span class="red-mark">*</span>
                        账单明细
                    </div>
                    <div class="right-btns">
                        <span @click="exportBtnFn(1)" class="blue-pointer">导出账单明细</span>
                        <span @click="exportBtnFn(2)" class="blue-pointer">导出订单明细（结算）</span>
                    </div>
                </div>
                <div class="tip-box">
                    <span class="attention">
                        注意：账单明细只结算分到豆包平台商户的订单收益，抖音商户的收益请到抖音商户里查询提现
                    </span>
                    <span @click="goDyWithdraw" class="blue-pointer">
                        去提现
                    </span>
                </div>
                <billDetailTable ref="billDetailTableRef" :tableData="paymentDetailData" style="margin-top: 14px;"></billDetailTable>
            </div>
            <div class="item-box">
                <div class="title-box">
                    <span class="red-mark">*</span>
                    请填写账户信息
                </div>
                <div class="item-content">
                    <el-form ref="refForm1" :rules="rules" label-position="left" label-width="80px" :model="formData">
                        <el-form-item label="账户名称" prop="account_name">
                            <el-input v-model="formData.account_name" class="form-ipt"></el-input>
                        </el-form-item>
                        <el-form-item label="账号" prop="account">
                            <el-input v-model="formData.account" class="form-ipt"></el-input>
                        </el-form-item>
                        <el-form-item label="开户银行" prop="bank_id">
                            <el-select v-model="formData.bank_id" placeholder="请选择开户银行">
                                <el-option
                                    v-for="item in bankList"
                                    :key="item.bank_id"
                                    :label="item.bank_name"
                                    :value="item.bank_id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="开户支行" prop="bank_branch">
                            <el-input v-model="formData.bank_branch" class="form-ipt"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="item-box">
                <div class="title-box">
                    <span class="red-mark">*</span>
                    上传发票
                    <span class="tip">只收6%增值税专用发票</span>
                </div>
                <div class="item-content invoice-box">
                    <div class="left">
                        <el-radio-group style="margin: 0 0 14px;" v-model="invoiceActiveTab">
                            <el-radio-button v-for="(item,index) in invoiceTabList" :key="index" :label="item.value">{{ item.label }}</el-radio-button>
                        </el-radio-group>
                        <div v-if="invoiceActiveTab==1">
                            <el-form ref="refForm2" :rules="rules" label-position="top" label-width="80px" :model="formData">
                                <el-form-item label="纸质发票物流单号" prop="invoice_pdf" key="invoice_pdf">
                                    <template #label>
                                        电子发票
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                支持上传类型：{{ uploadAccept.join('、') }}
                                            </div>
                                            <span><i class="el-icon-question" style="cursor: pointer;"></i></span>
                                        </el-tooltip>
                                        <span @click="uploadFn" class="blue-pointer mg-l">{{ formData.invoice_pdf ? '点击替换' : '点击上传'}}</span>
                                    </template>
                                    <div v-if="formData.invoice_pdf" style="margin-top: 10px;font-size: 15px;display: inline-block;">
                                        {{ formData.my_e_invoce_name }}
                                    </div>
                                </el-form-item>
                            </el-form>
                        </div>
                        <div v-else>
                            <el-form ref="refForm2" :rules="rules" label-position="top" label-width="80px" :model="formData">
                                <el-form-item label="纸质发票物流单号" prop="invoice_logistics_number" key="invoice_logistics_number">
                                    <el-input v-model="formData.invoice_logistics_number" class="form-ipt" style="margin-top: -20px;" size="mini" placeholder="请输入纸质发票物流单号"></el-input>
                                </el-form-item>
                                <el-form-item prop="invoice_image" key="invoice_image">
                                    <template #label>
                                        纸质发票照片
                                        <el-tooltip placement="top">
                                            <div slot="content">
                                                支持上传类型：{{ uploadAccept.join('、') }}
                                            </div>
                                            <span><i class="el-icon-question" style="cursor: pointer;"></i></span>
                                        </el-tooltip>
                                        <span @click="uploadFn" class="blue-pointer mg-l">{{ formData.invoice_image ? '替换图片' : '上传图片'}}</span>
                                    </template>
                                    <el-image v-show="formData.invoice_image"
                                        style="width: 100px; height: 100px"
                                        :src="formData.invoice_image" 
                                        :preview-src-list="[formData.invoice_image]">
                                    </el-image>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
                    <div class="right">
                        <div style="margin-bottom: 10px;">发票抬头信息</div>
                        <div>
                            <div v-for="(item, index) in headingdInfos" :key="index" class="heading-info">
                                <span v-if="item.title"> {{ item.title }}： </span>
                                <span>{{ item.content }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="btns-box">
                <el-button @click="$router.back()" style="margin-right: 40px;">上一步</el-button>
                <el-button type="primary" @click="submitFn">提交打款申请</el-button>
            </div>
        </template>

        <el-dialog title="提交成功" :visible.sync="successPopObj.showPop" @close="closeSuccessPop" width="600px" :show-close="false">
            <div class="successpop-box">
                <el-timeline style="width: 200px;">
                    <el-timeline-item
                        v-for="(activity, index) in timeLineItems"
                        :key="index"
                        :icon="activity.icon"
                        :type="activity.type"
                        :color="activity.color"
                        :size="activity.size"
                        :timestamp="activity.timestamp">
                        {{activity.content}}
                    </el-timeline-item>
                </el-timeline>
                <div class="info-box">
                    <div class="info-item" v-for="(item, index) in successPopObj.detail" :key="index">
                        <div class="title">{{ item.title }}</div>
                        <div class="content">
                            <span v-if="item.prop=='money'">¥</span>{{ item.value }}
                        </div>
                    </div>
                </div>
                <el-button @click="successPopObj.showPop=false" type="primary" style="width: 200px;margin-top: 30px;">完成</el-button>
            </div>
        </el-dialog>
        <uploadSmallFile ref="uploadSmallFileRef" @uploadSuccess="uploadSuccess" :maxSize="10" :showSuccessTip="true" uploadType="other" :accept="uploadAccept"></uploadSmallFile>
    </div>
</template>

<script>
    import billDetailTable from './components/billDetailTable.vue'
    import uploadSmallFile from '@/components/newUpload/uploadSmallFile.vue'
    import { exportAboutMixin } from '@/components/mixin/mixin.js'
    import { frontEndExportMixin } from '@/components/mixin/frontEndExportMixin.js'
    import { mapActions } from 'vuex'
    export default {
        components: {
            billDetailTable,
            uploadSmallFile,
        },
        mixins: [ exportAboutMixin, frontEndExportMixin ],
        data(){
            return {
                showAllContent: false,
                formData: {
                    account_name: '', // 账户名称
                    account: '', // 账号
                    bank_id: '', // 开户银行
                    bank_branch: '', // 开户支行
                    invoice_pdf: '', // 电子发票url
                    my_e_invoce_name: '', // 电子发票文件名称
                    invoice_logistics_number: '', // 物流单号
                    invoice_image: '', // 纸质发票照片
                },
                rules: {
                    account_name: [
                        { required: true, message: '请填写账户名称', trigger: 'blur' },
                    ],
                    account: [
                        { required: true, message: '请填写账号', trigger: 'blur' },
                    ],
                    bank_id: [
                        { required: true, message: '请选择开户银行', trigger: 'blur' },
                    ],
                    bank_branch: [
                        { required: true, message: '请填写开户支行', trigger: 'blur' },
                    ],
                    invoice_pdf: [
                        { required: true, message: '请上传电子发票', trigger: 'blur' },
                    ],
                    invoice_logistics_number: [
                        { required: true, message: '请填写纸质发票物流单号', trigger: 'blur' },
                    ],
                    invoice_image: [
                        { required: true, message: '请上传纸质发票照片' },
                    ]
                },
                headingdInfos: [ // 发票抬头信息
                    {title: '', content: '阿特莱斯(北京)网络科技有限公司'},
                    {title: '纳税人识别号', content: '91110108579050532J'},
                    {title: '公司地址', content: '北京市大兴区乐园路4号院2号楼5层2单元605'},
                    {title: '联系电话', content: '010-88142585'},
                    {title: '开户银行名称', content: '中国工商银行股份有限公司北京翠微路支支行'},
                    {title: '开户银行账号', content: '0200080909200183856'},
                ],
                invoiceActiveTab: 1, // 发票类型激活tab
                invoiceTabList: [{label: '电子发票',value: 1}, {label: '纸质发票',value: 2}], // 发票类型tabs
                successPopObj: { // 提交成功弹窗 相关
                    showPop: false,
                    detail: [
                        {title: '提现金额', prop: 'money', value: '--'},
                        {title: '收款账号', prop: 'account', value: '--'},
                        {title: '账户名称', prop: 'accountName', value: '--'},
                    ]
                },
                timeLineItems: [ // 时间线
                    {
                        content: '发起提现申请',
                        size: 'normal',
                        type: 'success',
                    },
                    {
                        content: '等待处理',
                        timestamp: '预计三个工作日到账',
                        size: 'large',
                        type: 'warning',
                        icon: 'el-icon-alarm-clock'
                    },
                    {
                        content: '到账成功',
                        size: 'normal',
                        type: 'info'
                    }
                ],
                bankList: [], // 银行列表
                query: { // 页面传过来的参数
                    date: '',
                    come_froms: []
                },
                paymentDetailData: { // 账单明细数据
                    my_list: [],
                    my_total_money: '--',
                } 
            }
        },
        computed:{
            uploadAccept(){ // 上传文件类型
                if(this.invoiceActiveTab==1){
                    return ['.pdf']
                }else{
                    return [".jpg", ".png", ".jpeg"]
                }
            }
        },
        created(){
            this.getQuery()
            this.getPaymentDetail()
            this.getBankList()
        },
        methods: {
            ...mapActions('withdrawal',['bankOption']),
            ...mapActions('toPublicPayment',['getPaymentListDetailAPI', 'submitPaymentApplyAPI']),
            // 点击 导出
            exportBtnFn(type){ // type: 1=导出账单明细 2=导出订单明细（结算） 
                if(type==1){
                    let newList = []
                    let billDetailTableHeaderList = this.$refs.billDetailTableRef.tableHeaderList
                    this.paymentDetailData.my_list.forEach(item=>{
                        let newItem = {}
                        billDetailTableHeaderList.forEach(item2=>{
                            newItem[item2.label] = item[item2.prop]
                        })
                        newList.push(newItem)
                    })
                    this.mixin_exportToCsv(newList, `${this.query.date}账单明细.csv`)
                }
                if(type==2){
                    // 异步导出
                    this.exportExcel(9, this.query)
                }
            },
            // 获取网页参数
            getQuery(){
                let query = this.$route.query
                for(let k in query){
                    query[k] = JSON.parse(window.atob(decodeURIComponent(query[k])))
                }
                this.query = query
                console.log('getQuery-query:',query)
            },
            // 获取账单明细
            async getPaymentDetail(){
                let res = await this.getPaymentListDetailAPI(this.query)
                this.showAllContent = true
                console.log("getPaymentDetail-res:",res)
                let my_list = []
                for(let k in res.list){
                    my_list.push(res.list[k])
                }
                this.paymentDetailData = { 
                    ...res, 
                    my_list, 
                    my_total_money: res.total_payment
                }
            },
            // 获取银行列表
            async getBankList(){
                let res = await this.bankOption()
                // console.log('getBankList-res:',res)
                this.bankList = res.bank
            },
            // 关闭提交成功弹窗
            closeSuccessPop(){
                this.$router.replace({
                    path: this.staticPath + 'applyPaymentHistory'
                })
            },
            // 上传成功
            uploadSuccess(e){
                console.log('uploadSuccess-e:',e)
                if(this.invoiceActiveTab==1){
                    this.formData.invoice_pdf = e.url
                    this.formData.my_e_invoce_name = e.origin_name || '电子发票'
                }
                if(this.invoiceActiveTab==2){
                    this.formData.invoice_image = e.url
                }
            },
            // 点击上传
            uploadFn(){ 
                this.$refs.uploadSmallFileRef.uploadFile()
            },
            // 跳转抖音商户页
            goDyWithdraw(){
                if(this.staticPath == '/'){
                    this.$router.replace({
                        path: this.staticPath + 'withdrawalSettings'
                    })
                }else{
                    localStorage.setItem('platPath','/')
                    localStorage.removeItem('breadCrumbList')
                    window.location.href = location.origin + '/withdrawalSettings'
                }
            },
            // 点击 提交打款申请
            async submitFn(){
                if(await this.validateFn()){
                    console.log("校验通过")
                    // 走接口进行提交
                    let params = {...this.formData}
                    if(this.invoiceActiveTab==1){ // 电子发票
                        delete params.invoice_image 
                        delete params.invoice_logistics_number 
                    }
                    if(this.invoiceActiveTab==2){ // 纸质发票
                        delete params.invoice_pdf
                        delete params.my_e_invoce_name
                    }
                    let res = await this.submitPaymentApplyAPI({
                        ...params,
                        ...this.query
                    })
                    console.log('submitFn-res:',res)
                    this.successPopObj.detail = [
                        {title: '提现金额', prop: 'money', value: this.paymentDetailData.my_total_money},
                        {title: '收款账号', prop: 'account', value: params.account},
                        {title: '账户名称', prop: 'accountName', value: params.account_name},
                    ]
                    this.successPopObj.showPop = true
                }else{
                    console.log("校验不通过")
                }
            },
            // 校验表单
            validateFn(){
                return new Promise((resolve)=>{
                    let tool = true
                    this.$refs.refForm1.validate((valid)=>{
                        // console.log('valid:',valid)
                        this.$refs.refForm2.validate((valid2)=>{
                            if(valid && valid2){
                                resolve(true)
                            }else{
                                resolve(false)
                            }
                        })
                    })
                })
            }
        }
    }
</script>

<style lang="less" scoped>
.wrap{
    .item-box{
        margin-bottom: 30px;
        .title-box{
            .red-mark{
                color: red;
            }
            .right-btns{
                >span{
                    margin-left: 20px;
                }
            }
            .tip{
                font-size: 14px;
                color: rgba(0, 0, 0, 0.5);
                margin-left: 10px;
            }
        }
        .tip-box{
            margin-top: 10px;
            >span{
                margin-right: 20px;
            }
            .attention{
                color: red;
                font-size: 14px;
            }
        }
        .item-content{
            width: 80%;
            margin-top: 10px;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 4px;
            padding: 18px 14px 8px;
            .form-ipt{
                width: 60%;
            }
        }
        .invoice-box{
            display: flex;
            justify-content: space-between;
            >div{
                width: 50%;
            }
            .left{
                /deep/ .el-form-item__label{
                    padding: 0; 
                }
            }
            .right{
                .heading-info{
                    margin-bottom: 6px;
                    font-size: 14px;
                }
            }
        }
    }
    .btns-box{
        display: flex;
        justify-content: center;
    }
    .successpop-box{
        display: flex;
        flex-direction: column;
        align-items: center;
        /deep/.el-timeline-item__node--large{
            top: -4px;
            left: -15px;
            width: 40px;
            height: 40px;
            .el-timeline-item__icon{
                font-size: 26px;
            }
            &+.el-timeline-item__wrapper{
                padding-left: 40px;
            }
        }
        .info-box{
            width: 240px;
            border-top: 1px solid #dedede;
            padding-top: 20px;
            .info-item{
                display: flex;
                justify-content: space-between;
                margin-bottom: 10px;
            }
        }
    }
}
.blue-pointer{
  cursor: pointer;
  color: #1989fa;
  font-size: 14px;
}
.mg-l{
    margin-left: 10px;
}

</style>